import PropTypes from "prop-types";

import StudentImage from "./StudentImage";
import T from "../translations/Translations";

import { gradeTranslator } from "../../const/Translations";

import "../../styles/StudentInfoBlock.scss";

/**
 * A component that will render a grey box with student information within
 * @param {*} param0
 * @returns {jsx}
 */
const StudentInfoBlock = ({ studentInfo }) => {
    const { currentLocationName, feederLocationName, futureLocationName, studentDto } = studentInfo;
    const { firstName, gradeName, lastName, studentNumber } = studentDto;
    const gradeNumber = gradeTranslator(gradeName);
    const newStudent = T({ key: "OE_New_Student" });
    const unavailable = T({ key: "OE_Unavailable" });
    return (
        <div className="student-block-container">
            <div className="photo-container">
                <StudentImage className="rounded-3" height={166} />
            </div>
            <div className="student-info-container">
                <div className="student-name">{`${firstName} ${lastName} - (${studentNumber || newStudent})`}</div>
                <p>
                    {T({ key: "OE_Form_Current_Grade" })}:<span>{gradeNumber || unavailable}</span>
                </p>
                <hr />
                <p>
                    {T({ key: "OE_Student_Info_Current_School" })}:{" "}
                    <span>
                        <i>{currentLocationName || unavailable}</i>
                    </span>
                </p>
                <hr />
                <p>
                    {T({ key: "OE_Student_Info_Neighborhood_School" })}:{" "}
                    <span>
                        <i>{feederLocationName || unavailable}</i>
                    </span>
                </p>
                <hr />
                <p>
                    {T({ key: "OE_Student_Info_Scheduled_School" })}:{" "}
                    <span>
                        <i>{futureLocationName || unavailable}</i>
                    </span>
                </p>
            </div>
        </div>
    );
};

StudentInfoBlock.propTypes = {
    studentInfo: PropTypes.oneOfType([PropTypes.object]).isRequired
};

export default StudentInfoBlock;
